import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-codex-quarter-view',
  templateUrl: './codex-quarter-view.component.html',
  styleUrls: ['./codex-quarter-view.component.scss']
})
export class CodexQuarterViewComponent implements OnInit {

  @Input() currentQuarter!: any;
  @Input() quarterList!: any[];

  @Output() emitQuarterChange = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  changeQuarter(index: number) {
    this.emitQuarterChange.emit(index);
  }

}
